import {useIntl} from 'react-intl'

/**
 * Localization shorthand over react-intl.
 *
 *   const t = useT()
 *   <Input label={t('HRM.EMPLOYEE.NAME_EN')} />
 *
 * Returns the localized string for a message id (from the active en/bn catalog in
 * `_metronic/i18n/messages`). If the key is missing it falls back to the id itself
 * so gaps are loud and easy to spot. Language is switched via the header switcher
 * (Metronic `setLanguage`) which reloads with the chosen locale.
 */
export const useT = () => {
  const intl = useIntl()
  return (id: string, values?: Record<string, any>) => intl.formatMessage({id}, values)
}
